import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const NominalCellEditor = forwardRef((props: any, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState(props.value?.toString() || "");

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;

    const pattern = new RegExp(/^[0123456789]+$/);
    if (pattern.test(input) || input == "") {
      setValue(input);
    }
  };

  const validateAndSave = () => {
    if (value == "") {
      return null;
    }
    return Number(value);
  };

  useImperativeHandle(ref, () => ({
    getValue: () => validateAndSave(),
  }));

  return (
    <input
      ref={inputRef}
      type="string"
      value={value}
      onChange={handleInput}
      className={`ag-input ag-roundedInputStyle flex w-full justify-center text-center`}
    />
  );
});

export default NominalCellEditor;
